module.exports = __webpack_public_path__ + "img/score_S.64c4974e.png";